import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $heading': {
      color: TextColors.light,
    },

    '& $divider': {
      background: hexToRGBA(TextColors.light, TextOpacities.light4),
    },
  },
};

const lightTheme = {
  root: {
    '& $heading': {
      color: TextColors.dark,
    },

    '& $divider': {
      background: hexToRGBA(TextColors.dark, TextOpacities.dark4),
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },
    content: {
      '& + *': {
        marginTop: muiTheme.spacing(5),
      },
    },
    description: {
      ...muiTheme.typography.body2,
    },
    heading: {
      '&.MuiTypography-root': {
        marginBottom: '13px',
      },
    },
    divider: {
      marginTop: '32px',
      marginBottom: '38px',
      width: '100%',
      height: '1px',
    },
  }),
  { name: 'GenPressCenterResourceAddtlContent' },
);

export default useStyles;
